import { Divider, message, Space, Tag } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    round10Decimals,
    ButtonItem,
    ErrorItem,
    TableItem,
} from "../../../../Components/Items";
import axios from "axios";
import AgregarAgrupacion from "../../Agrupaciones/AgregarAgrupacion/AgregarAgrupacion";
import EditarAgrupacion from "../EditarAgrupacion/EditarAgrupacion";


class ElegirAgrupacionesCliente extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        todasLotes: [],
        clienteId: null,
        insumoId: null,
        objetoClientes: null,
        objetoInsumos: null,
        agrupacionesElegidas: [],
        modalAgregarAgrupacion: false,
        modalAgregarAgrupacionLoteId: null,
        modalEditarAgrupacion: false,
        modalEditarAgrupacionAgrupacion: null
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarAgrupacionesDisponibles()
            this.setState({
                agrupacionesElegidas: [],
            })
        }
    }

    cerrarElegirAgrupacionesCliente(agregar) {
        if (agregar) {
            this.setState({ loading: true });
            axios
                .post(
                    "agrupaciones/agregarAgrupacionesAVenta",
                    { empresaId: this.props.empresaId, agrupacionesFiltradas: this.state.agrupacionesElegidas },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.props.cerrarElegirAgrupacionesCliente(res.data.insumosAgregar);
                        this.formRef.current.resetFields()
                    } else if (res.data.success === 1) {
                        message.warning(res.data.message)
                    } else {
                        message.error('Hubo un error y no se pudieron agregar los lotes')
                    }
                    this.setState({ loading: false });
                });
        } else {
            this.props.cerrarElegirAgrupacionesCliente([]);
            this.formRef.current.resetFields()
        }
    }

    async consultarAgrupacionesDisponibles(valores) {
        this.setState({ loading: true });
        await axios
            .post(
                "agrupaciones/selectAgrupacionesDisponiblesCliente",
                {
                    empresaId: this.props.empresaId,
                    proyectoId: this.props.proyectoId,
                    clienteId: this.props.clienteId
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({ todasLotes: res.data.lotesDisponibles });
                } else if (res.data.success === 1) {
                    message.warning(res.data.message)
                } else {
                    message.error('Hubo un error y no se pudo consultar los marbetes disponibles')
                }
            });
        this.setState({ loading: false });
    }

    onFinish() {
        this.cerrarElegirAgrupacionesCliente(true)
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    agregarLote(record) {
        this.setState({
            loading: true,
            modalAgregarAgrupacion: true,
            modalAgregarAgrupacionLoteId: record._id,
        });

    }

    cerrarAgregarAgrupacion(agregado, agrupacionAgregada) {
        if (agregado && agrupacionAgregada) {
            const agrupacionesElegidas = [...this.state.agrupacionesElegidas]
            agrupacionesElegidas.push(agrupacionAgregada);
            this.setState({
                loading: false,
                agrupacionesElegidas: agrupacionesElegidas,
                modalAgregarAgrupacion: false,
                modalAgregarAgrupacionLoteId: null,
            })
            this.consultarAgrupacionesDisponibles()
        } else {
            this.setState({
                loading: false,
                modalAgregarAgrupacion: false,
                modalAgregarAgrupacionLoteId: null,
            });
        }
    }


    agregarAgrupacion(record) {
        const agrupacionesElegidas = [...this.state.agrupacionesElegidas];
        if (!agrupacionesElegidas.some(lote => lote._id === record._id)) {
            this.setState({
                modalEditarAgrupacion: true,
                modalEditarAgrupacionAgrupacion: record
            })
            // agrupacionesElegidas.push(record);
            // this.setState({ agrupacionesElegidas });
        } else {
            message.warning("La agrupación ya ha sido agregado a la lista.");
        }
    }

    cerrarEditarAgrupacion() {
        const agrupacionesElegidas = [...this.state.agrupacionesElegidas]
        agrupacionesElegidas.push(this.state.modalEditarAgrupacionAgrupacion);
        this.consultarAgrupacionesDisponibles()
        this.setState({
            loading: false,
            modalEditarAgrupacion: false,
            modalEditarAgrupacionAgrupacion: null,
            agrupacionesElegidas
        });
    }


    editarAgrupacion(record) {
        const agrupacionesElegidas = [...this.state.agrupacionesElegidas];
        if (!agrupacionesElegidas.some(lote => lote._id === record._id)) {
            agrupacionesElegidas.push(record);
            this.setState({ agrupacionesElegidas });
        } else {
            message.warning("El lote ya ha sido agregado a la lista.");
        }
    }

    eliminarAgrupacion(record) {
        const agrupacionesElegidas = [...this.state.agrupacionesElegidas].filter(lote => lote._id !== record._id);
        this.setState({ agrupacionesElegidas });
    }

    render() {
        const columns = [
            {
                title: "Numero",
                dataIndex: "numero",
                key: "numero",
                width: "10%",
            },
            {
                title: "Etapa",
                dataIndex: "etapa",
                responsive: ["md"],
                key: "etapa",
                render: (value) => value ? <Tag color="blue">{value}</Tag> : null,
                width: "10%",
            },
            {
                title: "Concepto",
                dataIndex: "concepto",
                responsive: ["md"],
                key: "concepto",
                width: "20%",
                render: (value, record) => {
                    if (record.agrupacion) {
                        return "Agrupación" + (record?.descripcionInsumo ? ": " + record.descripcionInsumo : "");
                    }

                    if (record.lote) {
                        return "Lote" + (record?.descripcionInsumo ? ": " + record.descripcionInsumo : "");
                    }
                }
            },
            {
                title: "Piezas",
                dataIndex: "piezas",
                responsive: ["md"],
                key: "piezas",
                width: "15%",
                render: (value) => {
                    if (value) {
                        return (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                {value.map((pieza, index) => (
                                    <Tag color='blue'>
                                        {pieza.descripcion}
                                    </Tag>
                                ))}
                            </div>
                        );
                    }
                },
            },
            {
                title: "Proyecto",
                dataIndex: "proyecto",
                responsive: ["md"],
                key: "proyecto",
                render: (value) => value.nombre,
                width: "5%",
            },
            {
                title: "Cantidad",
                dataIndex: "cantidad",
                key: "cantidad",
                sorter: (a, b) => {
                    if (a.cantidad < b.cantidad) {
                        return -1;
                    }
                    if (a.cantidad > b.cantidad) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => round10Decimals(value).toFixed(4),
                width: "10%",
            },
            {
                title: "Accion",
                key: "accion",
                render: (value, record, index) => {

                    if (record.lote) {
                        return (
                            <Space>
                                <ButtonItem
                                    type="primary"
                                    onClick={() => {
                                        this.agregarLote(record);
                                    }}
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Agregar
                                </ButtonItem>
                            </Space>
                        )
                    }

                    if (record.agrupacion) {
                        return (
                            <Space>
                                <ButtonItem
                                    type="primary"
                                    onClick={() => {
                                        this.agregarAgrupacion(record);
                                    }}
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Agregar
                                </ButtonItem>
                            </Space>
                        )
                    }
                },
                width: "10%",
            }
        ];
        const columnsElegido = [
            {
                title: "Numero",
                dataIndex: "numero",
                key: "numero",
                width: "10%",
            },
            {
                title: "Etapa",
                dataIndex: "etapa",
                responsive: ["md"],
                key: "etapa",
                render: (value) => value ? <Tag color="blue">{value}</Tag> : null,
                width: "10%",
            },
            {
                title: "Concepto",
                dataIndex: "concepto",
                responsive: ["md"],
                key: "concepto",
                width: "20%",
                render: (value, record) => {
                    if (record.agrupacion) {
                        return "Agrupación" + (record?.descripcionInsumo ? ": " + record.descripcionInsumo : "");
                    }

                    if (record.lote) {
                        return "Lote" + (record?.descripcionInsumo ? ": " + record.descripcionInsumo : "");
                    }
                }
            },
            {
                title: "Piezas",
                dataIndex: "piezas",
                responsive: ["md"],
                key: "piezas",
                width: "15%",
                render: (value) => {
                    if (value) {
                        return (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                {value.map((pieza, index) => (
                                    <Tag color='blue'>
                                        {pieza.descripcion}
                                    </Tag>
                                ))}
                            </div>
                        );
                    }
                },
            },
            {
                title: "Proyecto",
                dataIndex: "proyecto",
                responsive: ["md"],
                key: "proyecto",
                render: (value) => value.nombre,
                width: "5%",
            },
            {
                title: "Cantidad",
                dataIndex: "cantidad",
                key: "cantidad",
                sorter: (a, b) => {
                    if (a.cantidad < b.cantidad) {
                        return -1;
                    }
                    if (a.cantidad > b.cantidad) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => round10Decimals(value).toFixed(4),
                width: "10%",
            },
            {
                title: "Accion",
                key: "accion",
                responsive: ["md"],
                render: (value, record, index) => (
                    <Space>
                        <ButtonItem
                            type="primary"
                            onClick={() => {
                                this.eliminarAgrupacion(record);
                            }}
                            style={{ display: "block", margin: "0 0 0 auto" }}
                            rojo
                        >
                            Eliminar
                        </ButtonItem>
                    </Space>
                ),
                width: "10%",
            }
        ];
        return (
            <>
                <ModalItem
                    title="Agregar Agrupacion a Cotizacion"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarElegirAgrupacionesCliente.bind(this)}
                    paddingTop
                    width={1200}
                >
                    <Form
                        ref={this.formRef}
                        name="ElegirAgrupacionesCliente"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Agregar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Divider>Lotes Elegidos</Divider>
                        <TableItem
                            size="small"
                            dataSource={this.state.agrupacionesElegidas}
                            columns={columnsElegido}
                            pagination={false}
                            locale={{
                                emptyText: "No hay lotes elegidos. Doble click en un lote para agregarlo.",
                            }}
                            onRow={(record, rowIndex) => {
                                return {
                                    onDoubleClick: (event) => {
                                        this.agregarLote(record);
                                    },
                                };
                            }}
                        />
                        <Divider>Lotes Disponibles</Divider>
                        <TableItem
                            size="small"
                            dataSource={this.state.todasLotes}
                            columns={columns}
                            pagination={false}
                            onRow={(record, rowIndex) => {
                                return {
                                    onDoubleClick: (event) => {
                                        this.agregarLote(record);
                                    },
                                };
                            }}
                        />
                    </Form>
                    <AgregarAgrupacion
                        visible={this.state.modalAgregarAgrupacion}
                        cerrarAgregarAgrupacion={this.cerrarAgregarAgrupacion.bind(this)}
                        loteId={this.state.modalAgregarAgrupacionLoteId}
                        headersToken={this.props.headersToken}
                        empresaId={this.props.empresaId}
                    />
                    <EditarAgrupacion
                        visible={this.state.modalEditarAgrupacion}
                        cerrarEditarAgrupacion={this.cerrarEditarAgrupacion.bind(this)}
                        agrupacionId={this.state.modalEditarAgrupacionAgrupacion?._id}
                        headersToken={this.props.headersToken}
                        empresaId={this.props.empresaId}
                        cancelarEdiciones
                        habilitarPiezas
                        ediciones={{
                            editarInsumosVenta: true
                        }}
                    />
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ElegirAgrupacionesCliente);
